import { render, staticRenderFns } from "./dubangHp.vue?vue&type=template&id=fdddd14c&scoped=true"
import script from "./dubangHp.vue?vue&type=script&lang=js"
export * from "./dubangHp.vue?vue&type=script&lang=js"
import style0 from "./dubangHp.vue?vue&type=style&index=0&id=fdddd14c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdddd14c",
  null
  
)

export default component.exports